<template>
  <div id="main">
    <div :style="{display: showMain}">
      <!-- 轮播图 -->
      <header>
        <div >
          <img style="height:5.07rem;" src= "../../../static/img/newWx/sliderHomePage.png" >
        </div>
      </header>
      <!-- 公告 -->
      <div class="announcement">
        <div class="left">
          <img style="width: 1.2rem" src="../../../static/img/newWx/announcement.png" >
        </div>
        <div class="center" style="width:70%;margin:0px auto;height:2.2rem;line-height: 2.2rem;">
          <div class="marquee_box">
            <ul class="marquee_list" :class="{marquee_top:animate}">
              <li @click="toAnnounceDetail(item)" v-for="(item, index) in marqueeList" :key="index">
                <span>{{item.title}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="right">
          <img @click="toAnnounceList" style="width: .35rem" src="../../../static/img/newWx/rightArr.png" >
        </div>
      </div>
      <!-- 导航栏 -->
      <nav>
        <div @click="toRepair">
          <img style="width: .75rem;height:.75rem;" src="../../../static/img/newWx/complain.png" ><span>居家维修</span>
        </div>
        <div @click="toOpen">
          <img style="width:.45rem;height: .75rem;" src="../../../static/img/newWx/openDoor.png" ><span>一键开门</span>
        </div>
        <div @click="toPay">
          <img style="width: .7rem;height: .7rem;" src="../../../static/img/newWx/pay.png" ><span style="margin-top:.35rem">物业缴费</span>
        </div>
        <div @click="toService">
          <img style="width:29px;height:25px;" src="../../../static/img/newWx/moneyService.png" >
          <span style="margin-top:.39rem">有偿服务</span>
        </div>
        <div @click="toAdvice">
          <img style="width:31px;height:27px;" src="../../../static/img/newWx/advice.png" ><span style="margin-top:.33rem">意见建议</span>
        </div>
      </nav>
      <!-- 专职管家 -->
      <div class="manager">
        <h4>专职管家</h4>
        <ul>
          <li v-if="managerList.length !== 0" v-for="(item,index) in managerList" :key="index">
            <div class="left">
              <img style="width:50px;height:50px;" v-if="item.managerHeadpicture" :src="'data:image/png;base64,' + item.managerHeadpicture" >
              <img style="width:50px;height:50px;"  v-if="!item.managerHeadpicture" src="/static/img/newWx/defaultAvator.png" >
              <div class="nameAndTel">
                <p class="c999" v-if="item.managerName">{{item.managerName}}</p>
                <p class="c999" v-else>暂无管家名称</p>
                <p class="c333" v-if="item.managerMobile">{{item.managerMobile}}</p>
                <p class="c333" v-else>暂无手机号</p>
              </div>
            </div>
            <div class="right ">
              <a :href="'tel:' + item.managerMobile "><img style="width:42px;height:42px;" src="../../../static/img/newWx/call.png" ></a>
            </div>
          </li>
          <li v-if="managerList.length === 0" style="width: 90%;height: 2rem;line-height: 1.4rem;font-size: .5rem">管家信息不全</li>
        </ul>
      </div>
      <!-- 社区活动 -->
      <div class="community">
        <h4>社区活动</h4>
        <div class="communityList">
          <ul>
            <li v-for="(item,index) in comList" :key="index">
              <a href="javascript:;" >
                <viewer >
                  <img :src="item.url" >
                </viewer>
                <!-- <span >{{item.title}}</span> -->
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 底部按钮 -->
      <footer>
        <img @click="toMy" style="width:64px;height:64px;" src="../../../static/img/newWx/bottonMy.png" alt="">
      </footer>
    </div>
    <!-- 有偿服务得图片 -->
    <div class="serviceImg"  style="width:100%;"  :style="{display: showFlag}">
      <viewer >
        <img  style="width:100%;" src="../../../static/img/newWx/sf1226.png" >
      </viewer>
    </div>
    <!--弹窗-->
    <div v-if="sec4" class="sec4"></div>
    <section v-if="popUp" class="popUp">
      <img @click="close" src="../../../static/img/close.png">
      <p v-if="pa" class="pa">您还未绑定手机号，请立即去绑定</p>
      <p v-if="pb" class="pb">您还没有房产信息，请点击获取房产或点击更换手机号</p>
      <div v-if="pa" class="diva">
        <input @click="bangDing" type="text" value="绑定">
      </div>
      <div v-if="pb" class="divb clear">
        <input @click="fangchanxinxi" class="float-f" type="text" value="同步房产">
        <input @click="bangDing" class="float-r" type="text" value="更换手机号">
      </div>
    </section>
  </div>
</template>
<script>
  export default {
    // name: 'images',
    data() {
      return {
        showFlag: 'none',
        showMain: 'block',
        marqueeList: [],
        fullControl: false, //是否全屏
        animate: false,
        sec4: false,
        popUp: false,
        pa: false,
        pb: false,
        sliderinit: {
          currentPage: 0,
          thresholdDistance: 100,
          thresholdTime: 300,
          autoplay: 2000,
          loop: true,
          infinite: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          duration: 500,
          typeNum: 0
        },
        currentTime: '',
        comList: [
          {url: '../../static/img/newWx/banner1.jpg'},
          {url: '../../static/img/newWx/banner2.jpg'},
          {url: '../../static/img/newWx/banner3.jpg'},
          {url: '../../static/img/newWx/banner4.jpg'},
          {url: '../../static/img/newWx/banner5.jpg'},
          {url: '../../static/img/newWx/banner6.jpg'},
        ],
        managerList: [] //管家列表
      }
    },
    created: function () {
      setInterval (this.showMarquee, 2000)
      // 当前时间
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth();
      let date = now.getDate();
      this.currentTime = year + '年' + (month + 1) + '月' + date + '日 '
    },
    mounted(){
      let that = this;
      that.getAnnounceList();
      // that.postRequest('/capp-notice/notice/we/chat/open/findNoticeLimit',{
      //   // appId : 'wxe7bb99f7923d250c',
      //   appId : sessionStorage.getItem('appId'),
      //   username : sessionStorage.getItem('userName')
      // },function(data){
      //   console.log(data)
      //   that.marqueeList = data.datas
      // },'n')
      // 获取管家
      that.getManagerList();
    },
    methods: {
      //获取公告
      getAnnounceList(){
        let that = this;
        //获取公告
        that.postRequest('/cowner/notice/open/findNoticeLimit',{

        },function(data){
          console.log(data)
          that.marqueeList = data
        },'n')
      },
      //获取管家
      getManagerList(){
        let _this = this;
        _this.postRequest('house/houseManagerList',{

        },function (data) {
          console.log(data)
          _this.managerList = data
        })
      },
      //公告跑马灯
      showMarquee: function () {
        this.animate = true;
        setTimeout (() => {
          this.marqueeList.push (this.marqueeList[ 0 ]);
          this.marqueeList.shift ();
          this.animate = false;
        }, 500);
      },
      // 点击我的 跳转我的页面，获取关注的人的微信的信息包括 头像和昵称
      toMy() {//我的
        this.$router.push({name: 'my'})
      },
      close() {
        this.popUp = false
        this.sec4 = false
      },
      bangDing() {
        this.$router.push({name: 'checkTel'})
      },
      fangchanxinxi() {
        this.$router.push({name: 'houseInfo'})
      },
      initAddress() {
        const _this = this
        _this.postRequest('house/queryByUserId', {}, function (data) {
          if (data.length <= 0) {
            //弹窗
            _this.pb = true
            _this.popUp = true
            _this.sec4 = true
          } else {
            sessionStorage.setItem('el', data[0].name)
            sessionStorage.setItem('houseid', data[0].id)
            switch (_this.typeNum) {
              case 1:
                _this.$router.push({
                  name: 'repair',
                  params: {
                    house: data
                  }
                })
                break;
              case 2:
                _this.$router.push({
                  name: 'complain',
                  params: {
                    house: data
                  }
                })
                break;
              case 3:
                _this.$router.push({
                  name: 'pay',
                  params: {
                    house: data
                  }
                })
                break;
            }
          }
        })
      },
      acquireIphone() {
        const _this = this
        _this.postRequest('user/currentUserDetail ', {}, function (data) {
          if (data.phone) {
            _this.initAddress()
          } else {
            //弹窗
            _this.pa = true
            _this.popUp = true
            _this.sec4 = true
          }
        })
      },
      scroll() {
        this.animate = true
        setTimeout(() => {
          this.marqueeList.push(this.marqueeList[0])
          this.marqueeList.shift()
          this.animate = false
        }, 1500)
      },
      toRepair() {//报修
        this.typeNum = 1
        this.acquireIphone()
      },
      // 去一键开门
      toOpen(){
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9254dbd620944b65&redirect_uri=http://lswx.lesoft.com.cn/opendoor/ms/wechat1.html&response_type=code&scope=snsapi_userinfo&state=1234&connect_redirect=1#wechat_redirect'
      },
      // 点击查看有偿服务图片
      toService(){
        this.showFlag='block';
        this.showMain='none';
      },
      // 去投诉建议
      toAdvice(){
        this.typeNum = 2
        this.acquireIphone()
      },
      //缴费
      toPay() {
        this.typeNum = 3
        this.acquireIphone()
      },
      // 查看公告列表
      toAnnounceList(){
        this.$router.push('announce')
      },
      // 查看公告详情
      toAnnounceDetail(item){
        console.log(item)
        this.$router.push({
          name: 'announceDetail',
          params: {
            noticeId: item.id
          }
        })
      },
    }
  }
</script>
<style scoped>
  /*公告*/
  #main .swiper-container-vertical .slider-pagination-bullets {
    display: none;
  }
  #main .announcement{
    width:100%;
    height: 2.2rem;
    line-height: 2.2rem;
    display: flex;
    justify-content: space-between;
    padding-bottom: .2rem;
    box-sizing: border-box;
    border-bottom: .15rem solid rgba(207, 207 ,207, .3);
  }
  #main .announcement ul li{
    color: #666;
    font-size: .4rem;
    width: 100%;
    height: .7rem;
    line-height: .6rem;
  }
  #main .announcement> .left{
    margin: .5rem 0 0 .5rem;
  }
  #main .announcement> .center{
    height: 3rem;
  }
  #main .announcement> .right{
    margin-right: .4rem;
    margin-top: -.25rem;
  }
  /*导航栏*/
  #main  nav{
    display: flex;
    justify-content: space-around;
    margin: .8rem 0;
  }
  #main  nav div {
    width: 100px;
    text-align: center;
  }
  #main  nav div span{
    margin-top: .3rem;
    display: inline-block;
  }
  /* 专职管家*/
  .c333{
    color:#333;
  }
  .c999{
    color:#999;
  }
  #main .manager{
    margin-bottom: .8rem;
  }
  #main .manager h4,.community h4{
    font-size: .5rem;
    margin:0 0 .3rem .4rem;
    color: #333;
    /* font-weight: 400; */
    text-align: left;
  }
  #main .manager ul{
    width: 90%;
    margin: 0 auto;
    height: 2.5rem;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    justify-content: flex-start;
  }
  #main .manager ul::-webkit-scrollbar{
    height: .05rem;
  }
  #main .manager ul li{
    /*width: 90%;*/
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    padding-top: .5rem;
    border: 1px solid #eee;
    box-sizing: border-box;
  }
  #main .manager li .left{
    /*width: 85%;*/
    display: flex;
    justify-content: space-around;
    padding:0 2rem 0 0;
    box-sizing: border-box;
    margin-left: .35rem;
  }
  #main .manager li .left img{
    border-radius: 200%;
    margin-right: .3rem;
  }
  #main .manager li .left .nameAndTel{
    width: 3rem;
    font-size: .4rem;
    text-align: left;
    /*padding: .1rem 0;*/
    /*box-sizing: border-box;*/
  }
  #main .manager li .left .nameAndTel p:first-child{
    margin-bottom: .5rem;
  }
  #main .manager .right{
    margin-right: 1rem;
  }
  #main .manager .right a{
    display: inline-block;
    width: 100%;
    height: 100%;
    margin-top: .1rem;
  }
  /*社区活动*/
  .community{
    margin-bottom: .8rem;
  }
  .community .communityList{
    overflow-x: auto;
  }
  .community .communityList ul{
    height: 2.95rem;
    overflow-x: auto;
    padding: 0 .4rem;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
  }
  .community .communityList ul::-webkit-scrollbar{
    height: .05rem;
  }
  .community .communityList ul li{
    margin-right: .35rem;
  }
  .community .communityList ul li a{
    display: inline-block;
    position: relative;
  }
  .community .communityList ul li a img{
    width: 4.4rem;
    height:2.9rem;
  }
  .community .communityList ul li a span{
    position:absolute;
    width: 100%;
    padding-left: .2rem;
    box-sizing: border-box;
    left:0;
    bottom: .1rem;
    height:.9rem;
    line-height:.9rem;
    color:#fff;
    background-color:rgba(0,0,0,.6);
  }
  /*底部 我的*/
  #main  footer{
    margin-top: .2rem;
    text-align: center;
  }
  /*跑马灯*/
  .marquee_box {
    display: block;
    position: relative;
    width: 100%;
    height: 1.2rem;
    margin-top: .5rem;
    overflow: hidden;
  }
  .marquee_list {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
  .marquee_top {
    transition: all 0.5s;
    margin-top: -.5rem;
  }
  .marquee_list li {
    height: .5rem;
    line-height: .4rem;
    font-size: .15rem;
    padding-left: .4rem;
    box-sizing: border-box;
  }
  .marquee_list li span {
    display: inline-block;
    padding: 0 2px;
    box-sizing: border-box;
    width: 6.6rem;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  >>> img{
    /* width: 3rem; */
  }
  /*是否 全屏*/
  .fullScreen{
    transform: scale(3);
    position: absolute;
    z-index: 100;
    /* width: 100%; */
  }
  /*遮罩样式*/
  .sec4 {
    width: 100%;
    height: 1334px;
    background: #000000;
    opacity: .4;
    z-index: 10;
    position: fixed;
    top: 0;
  }

  .clear {
    overflow: hidden;
    zoom: 1;
  }

  .float-f {
    float: left;
  }

  .float-r {
    float: right;
  }

  .popUp {
    z-index: 20;
    background: #fff;
    border-radius: 10px;
    width: 88%;
    height: 302px;
    position: fixed;
    top: 480px;
    left: 50%;
    transform: translateX(-50%);
  }

  .popUp img {
    width: 28px;
    height: 28px;
    margin-left: 620px;
    margin-top: 16px;
  }

  /*绑定弹框*/
  .popUp .pa {
    line-height: 70px;
    font-size: 28px;
    text-align: center;
  }

  .popUp .diva input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 60px 0 0 200px;
  }

  /*获取房产 和 更换手机号 弹框*/
  .popUp .pb {
    width: 75%;
    padding: 0 40px;
    text-align: center;
    margin: 30px 0;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
  }

  .popUp .divb {
    margin-top: -10px;
    margin: 0 50px;
  }

  .popUp .divb input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 10px 0;
  }

  /* 固定二倍图尺寸 */
  .more2 {
    width: 12px;
    height: 21px;
  }

  .fl {
    float: left;
  }

  #main {
    width: 100%;
    background-color: #fff;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/mingsheng/homePage-mingsheng.vue